module.exports = __webpack_public_path__ + "static/media/farmacia_alves_oliveira.e2033a57.png";